jQuery(function($) {
	$(".btn--associados").on("click", function () {
		var navHeight = $(".n-associados").outerHeight();
		var menuHeight = 0;
		var menuSticky = $('.c-menu').css('position') === 'sticky';
		if(menuSticky) {
			menuHeight = $(".c-menu").outerHeight();
		}

		var adminBar = 0;
		var hasAdminBar = $('#wpadminbar').length > 0;
		if(hasAdminBar) {
			adminBar = $("#wpadminbar").outerHeight();
		}

		$(".associados__wrapper, .btn--associados").removeClass('active');
		$(this).addClass('active');
		var target = $(this).attr("data-target");

		$(".associados--" + target).addClass("active");
		$('html, body').stop().animate({ scrollTop: $(".s-associados").offset().top - navHeight - menuHeight}, 600);
	});
});
